import React, { useState } from 'react'
import axios from 'axios'

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api'
})

export default function RegistrationStatusPage() {
  const [refNo, setRefNo] = useState('')
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleCheck = async () => {
    setError('')
    setResult(null)
    if (!refNo.trim()) { setError('กรุณากรอกหมายเลขอ้างอิง'); return }
    setLoading(true)
    try {
      const res = await publicApi.get(`/registration/status/${refNo.trim()}`)
      setResult(res.data.data)
    } catch (err) { setError(err.response?.data?.message || 'ไม่พบหมายเลขอ้างอิงนี้ในระบบ') }
    finally { setLoading(false) }
  }

  const statusConfig = {
    pending:  { label: 'รอการตรวจสอบ',     color: '#f59e0b', bg: '#fef9c3', icon: 'ti-clock-hour-4' },
    approved: { label: 'อนุมัติแล้ว',        color: '#22c55e', bg: '#f0fdf4', icon: 'ti-circle-check' },
    rejected: { label: 'ไม่ผ่านการพิจารณา', color: '#ef4444', bg: '#fef2f2', icon: 'ti-x' },
    active:   { label: 'ใช้งานแล้ว',         color: '#3b82f6', bg: '#eff6ff', icon: 'ti-circle-check' },
  }

  const inputStyle = { width: '100%', padding: '12px', border: '0.5px solid #e2e8f0', borderRadius: '12px', fontSize: '14px', color: '#0f172a', background: 'white', outline: 'none', fontFamily: 'inherit' }

  return (
    <div className="public-form-page" style={{ minHeight: '100vh', background: '#f3f8ff' }}>
      {/* Header */}
      <div className="public-form-header" style={{ background: 'linear-gradient(110deg, #063b91, #075dcc, #1594df)', padding: '22px 16px', textAlign: 'center' }}>
        <p style={{ color: 'white', fontWeight: '500', fontSize: '16px' }}>ตรวจสอบสถานะการลงทะเบียน</p>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px', marginTop: '2px' }}>เทศบาลนครมาบตาพุด</p>
      </div>

      <div style={{ maxWidth: '440px', margin: '0 auto', padding: '24px 16px' }}>
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '24px', marginBottom: '14px' }}>
          <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a', marginBottom: '4px' }}>กรอกหมายเลขอ้างอิง</p>
          <p style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '16px' }}>หมายเลขอ้างอิงที่ได้รับหลังจากลงทะเบียน เช่น REG-2569-A1B2C3D4</p>

          <input type="text" value={refNo}
            onChange={e => setRefNo(e.target.value.toUpperCase())}
            placeholder="REG-2569-XXXXXXXX"
            onKeyDown={e => e.key === 'Enter' && handleCheck()}
            style={{ ...inputStyle, textAlign: 'center', letterSpacing: '0.1em', fontWeight: '500', marginBottom: '10px' }} />

          {error && (
            <div style={{ background: '#fef2f2', border: '0.5px solid #fecaca', color: '#ef4444', borderRadius: '10px', padding: '10px 14px', marginBottom: '10px', fontSize: '13px' }}>{error}</div>
          )}

          <button className="ui-shine-button" onClick={handleCheck} disabled={loading}
            style={{ width: '100%', padding: '12px', background: loading ? '#a5b4fc' : '#075dcc', color: 'white', border: 'none', borderRadius: '12px', fontSize: '14px', fontWeight: '500', cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'กำลังตรวจสอบ...' : 'ตรวจสอบสถานะ'}
          </button>
        </div>

        {result && (
          <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '24px' }}>
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <p style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '4px' }}>หมายเลขอ้างอิง</p>
              <p style={{ fontSize: '18px', fontWeight: '500', color: '#0f172a', letterSpacing: '0.05em' }}>{result.ref_no}</p>
            </div>

            {result.status && statusConfig[result.status] && (
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 18px', borderRadius: '999px', fontSize: '13px', fontWeight: '500', color: statusConfig[result.status].color, background: statusConfig[result.status].bg }}>
                  <i className={`ti ${statusConfig[result.status].icon}`} style={{ fontSize: '16px' }} />
                  {statusConfig[result.status].label}
                </span>
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {[
                ['ชื่อ-นามสกุล', result.full_name],
                ['ตำแหน่ง', result.position],
                ['อัปเดตล่าสุด', result.updated_at ? new Date(result.updated_at).toLocaleDateString('th-TH') : null],
              ].filter(([, v]) => v).map(([label, value]) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '0.5px solid #f1f5f9' }}>
                  <span style={{ fontSize: '12px', color: '#94a3b8' }}>{label}</span>
                  <span style={{ fontSize: '13px', fontWeight: '500', color: '#0f172a' }}>{value}</span>
                </div>
              ))}
            </div>

            <div style={{ marginTop: '16px', background: '#f8fafc', borderRadius: '10px', padding: '12px', textAlign: 'center' }}>
              <p style={{ fontSize: '11px', color: '#94a3b8' }}>หากมีข้อสงสัย ติดต่อ งานบุคคล โทร. 038-685-562 ต่อ 108</p>
            </div>
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <a href="/register" style={{ color: '#075dcc', fontSize: '13px', textDecoration: 'none' }}>← กลับหน้าลงทะเบียน</a>
        </div>
      </div>
    </div>
  )
}
